/* global axios */
import ApiClient from './ApiClient';

// Entrada de estoque por nota fiscal: XML da NF-e ou PDF/foto lidos pela Lia.
class TalkviaInventoryInvoicesAPI extends ApiClient {
  constructor() {
    super('talkvia_inventory_invoices', { accountScoped: true });
  }

  preview(file) {
    const form = new FormData();
    form.append('file', file);
    return axios.post(`${this.url}/preview`, form);
  }

  readWithAi(file) {
    const form = new FormData();
    form.append('file', file);
    return axios.post(`${this.url}/read_with_ai`, form);
  }

  create(invoice) {
    return axios.post(this.url, { invoice });
  }
}

export default new TalkviaInventoryInvoicesAPI();
